import { html, LitElement, PropertyValues } from 'lit';
import { customElement } from 'lit/decorators';

import '@carbon/web-components/es/components/tile/tile.js';
import '@carbon/web-components/es/components/progress-indicator';
import '@carbon/web-components/es/components/code-snippet/code-snippet.js';

import { unsafeHTML } from 'lit-html/directives/unsafe-html';
import '../flow/pdq-json';
import '../flow/pdq-view';
import '../flow/pdq-perspective-viewer';
import '../sqlite/pdq-sqlite-console';
import '../sqlite/pdq-sqlite-perspective-link';
import '../sqlite/pdq-sqlite-database';
import './PDQCodeHtml';
import CodeIcon from '@carbon/web-components/es/icons/code/16';
import { tableBroker } from '../services/TableBroker';
import { SIDE_NAV_COLLAPSE_MODE } from '@carbon/web-components/es/components/ui-shell/defs';


@customElement('pdq-tutorial-sqlite-from-perspective')
export class PDQTutorialSqliteFromPerspective extends LitElement {
  render() {
    const codeStatements = `
<pdq-sqlite-local-database database="tutorial.db" ></pdq-sqlite-local-database>
<pdq-data-request id="posts-data" url="https://jsonplaceholder.typicode.com/posts"></pdq-data-request>
<pdq-table id="posts" source="posts-data" ></pdq-table>
<pdq-sqlite-perspective-link database="tutorial.db" table="posts" sqlite-table="posts"></pdq-sqlite-perspective-link>

<pdq-data-request id="users-data" url="https://jsonplaceholder.typicode.com/users"></pdq-data-request>
<pdq-table id="users" source="users-data" ></pdq-table>  
<pdq-sqlite-perspective-link database="tutorial.db" table="users" sqlite-table="users"></pdq-sqlite-perspective-link>

<pdq-sqlite-query database="tutorial.db" table="post-count" sqlite-table="posts">
<script type="application/sql" slot="query">
  SELECT u.username, u.name, COUNT(*) as postsCount
  FROM posts p 
  LEFT JOIN users u on u.id = p.userId 
  GROUP BY userId;
</script>
</pdq-sqlite-query>
<pdq-perspective-viewer id="posts-count-viewer" table="post-count"></pdq-perspective-viewer>
`
    return html`
      <cds-tile>
        <h1>SQLite - Linked From Perspective Table</h1>

        <pdq-code-html code="${codeStatements}"></pdq-code-html>
        ${unsafeHTML(codeStatements)}

        <pdq-sqlite-console title="Sqlite Interactive Console" database="tutorial.db" style="height:500px; display: block">
          <script type="application/sql" slot="query">
            SELECT u.username, u.name, COUNT(*) as postsCount
            FROM posts p 
            LEFT JOIN users u on u.id = p.userId 
            GROUP BY userId;
          </script>
        </pdq-sqlite-console>

      </cds-tile>

    `;
  }

  protected firstUpdated(_changedProperties: PropertyValues) {
    super.firstUpdated(_changedProperties);
    // tableBroker.getTable('post-count').subscribe(async i => {
    //   const view = await i.view();
    //   const json =  await view.to_json()
    //   console.log('*\n*\n*\n*\n*\n*\n*\n*\n*\n', json);
    // })
  }
}

